import { Component, OnInit, OnDestroy } from "@angular/core";
import { constant } from "./shared/constants/constant";
import { SignalRHubService } from "./shared/services/signalr-hub.service";
import { NotificationService } from "./shared/services/notification.service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { ThemeService } from "./shared/services/theme.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Shop";
  private subscriptions: Subscription[] = [];

  constructor(
    private signalRHub: SignalRHubService,
    private notificationService: NotificationService,
    private toastr: ToastrService,
    private themeService: ThemeService, // Inject to trigger theme initialization
  ) { }

  ngOnInit(): void {
    // Khởi tạo SignalR connection khi app start (nếu đã có token)
    this.initializeSignalR();
  }

  ngOnDestroy(): void {
    // Cleanup
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.signalRHub.stopConnection();
  }

  /**
   * Khởi tạo SignalR connection
   */
  private initializeSignalR(): void {
    // Lấy token từ localStorage
    const token = localStorage.getItem(constant.LOCALSTORAGE_KEY);

    if (!token) {
      console.warn("No token found, skipping SignalR connection");
      return;
    }

    // Start SignalR connection (Legacy 2.x - token passed via query/header logic handled in service if needed)
    this.signalRHub.startConnection();

    // Lắng nghe notifications từ SignalRHubService
    this.subscriptions.push(
      this.signalRHub.onNotificationReceived.subscribe((notification) => {
        if (notification) {
          this.handleNotificationReceived(notification);
        }
      }),
    );
  }

  /**
   * Xử lý khi nhận notification từ SignalR
   */
  private handleNotificationReceived(notification: any): void {
    console.log("New notification received:", notification);

    // Hiển thị Toast notification
    this.showToast(notification);

    // Refresh unread count
    this.notificationService.getUnreadCount().subscribe();

    // Optional: Play sound
    // this.playNotificationSound();
  }

  /**
   * Hiển thị Toast notification
   */
  private showToast(notification: any): void {
    const title = notification.Title || notification.title || "Thông báo";
    const message = notification.Content || notification.content || "";
    const type = (
      notification.Type ||
      notification.notificationType ||
      "Info"
    ).toLowerCase();

    // Show toast dựa vào type
    switch (type) {
      case "success":
        this.toastr.success(message, title, {
          timeOut: 5000,
          progressBar: true,
          closeButton: true,
          enableHtml: true,
        });
        break;
      case "warning":
        this.toastr.warning(message, title, {
          timeOut: 7000,
          progressBar: true,
          closeButton: true,
          enableHtml: true,
        });
        break;
      case "error":
        this.toastr.error(message, title, {
          timeOut: 10000,
          progressBar: true,
          closeButton: true,
          enableHtml: true,
        });
        break;
      default:
        this.toastr.info(message, title, {
          timeOut: 5000,
          progressBar: true,
          closeButton: true,
          enableHtml: true,
        });
    }
  }

  /**
   * Optional: Play notification sound
   */
  private playNotificationSound(): void {
    const audio = new Audio("assets/sounds/notification.mp3");
    audio.play().catch((err) => console.warn("Cannot play sound:", err));
  }
}
